import { render } from "./ConfiguracaoAtividade.vue?vue&type=template&id=567e5894&scoped=true"
import script from "./ConfiguracaoAtividade.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoAtividade.vue?vue&type=script&lang=js"

import "./ConfiguracaoAtividade.vue?vue&type=style&index=0&id=567e5894&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567e5894"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInput,QRadio,QTable,QBtn,QTd});
